<div class="row ms-2 me-2">
    <div class="col-lg-1">  
            <button type="button" class="btn blue-btn btn-sm ml-3 mt-1"
                (click)="exportClientAuthorizationReportCsv()" [disabled]="global.globalAgencyId==0 || !isEnabledExcel" id="exportClientAuthorizationReportCsv">
                <i class="fa fa-file-excel-o mr-1" ></i>Export</button>
    </div>

</div>
<div class="row ms-2 me-2 mt-1">
    <div class="col-lg-12">
        <ejs-grid #gridAuthorization [dataSource]='dataAuthorizationReport |async' [allowResizing]='true'
            [allowSorting]='true' [allowFiltering]='true' [allowPaging]='true'
            (dataStateChange)='dataStateChange($event)' (actionBegin)="onComplete($event)"
            [filterSettings]='filterSettings' [pageSettings]='initialPage ' [showColumnChooser]='true'
            (resizeStop)="onResize($event)">
            <e-columns>
                <e-column width="100" field="clientName" headerText="ClientName" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>

                <e-column width="100" field="startDate" headerText="StartDate" type='date' [allowSorting]='true'
                    [allowFiltering]="false" [format]='formatOptions'></e-column>
                <e-column width="100" field="endDate" headerText="EndDate" type='date' [allowSorting]='true'
                    [allowFiltering]="false" [format]='formatOptions'></e-column>
                <e-column width="100" field="address" [allowSorting]='false' [allowFiltering]="false"
                    headerText="Address" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>


                <e-column width="100" field="email" [allowSorting]='false' [allowFiltering]="false" headerText="Email"
                    type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="phone1" [allowSorting]='false' [allowFiltering]="false" headerText="Phone"
                    type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="location" headerText="Location" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="company" headerText="Company" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="payor" headerText="Payor" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="serviceCode" headerText="Service" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="serviceDescription" headerText="Service Description" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="150" field="employeeNames" headerText="Employee" type="string" [allowFiltering]="false">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="100" field="netRate" headerText="Net Rate" type='number' [allowSorting]='false'
                    [allowFiltering]="false"></e-column>
                <e-column width="100" field="ucRate" headerText="Uc Rate" type='number' [allowSorting]='false'
                    [allowFiltering]="false"></e-column>

                <e-column width="100" field="totalUnits" headerText="Total units" type='number'></e-column>

                <e-column width="100" field="hoursPerDay" headerText="HoursPerDay" [allowSorting]='false'
                    [allowFiltering]="false">
                </e-column>
                <e-column Width=100 field="unitsRemaining" headerText="Units Remaining">
                </e-column>
                <e-column Width=100 field="remainingHoursPerDay" headerText="Remaining HoursPerDay"
                    [allowSorting]='false' [allowFiltering]="false">
                </e-column>
                <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                        <div class="d-none d-lg-block">
                            <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                </i></span>
                        </div>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div class="col-lg-12">
        <div *ngIf="AuthorizationList.length == 0" class="text-center" style="color:red">
            <p>No data available</p>
        </div>
    </div>
</div>

